<ng-container *ngIf="status">
  <ng-container *ngIf="status === 'logout'" data-test="logout-message">
    <cigna-leaf-alert
      headerText="Thanks for visiting the Evernorth for Health Care Professionals."
      variant="banner"
      status="notification"
      [notDismissible]="true"
      class="alert-block"
      >As a security practice, please close your browser. This will help protect
      content from any unauthorized users.</cigna-leaf-alert
    >
  </ng-container>

  <ng-container *ngIf="status === 'timeout'" data-test="timeout-message">
    <cigna-leaf-alert
      headerText="Due to 30 minutes of inactivity, you've been logged out."
      variant="banner"
      status="warning"
      [notDismissible]="true"
      class="alert-block"
      >Thank you for visiting the Evernorth for Health Care Professionals
      website.</cigna-leaf-alert
    >
  </ng-container>

  <ng-container *ngIf="status === 'deactive'" data-test="eft-error-message">
    <cigna-leaf-alert
      headerText="Account Temporarily Locked."
      variant="banner"
      status="error"
      [notDismissible]="true"
      class="alert-block"
      >Alert: This user's access is temporarily locked until
      {{ dateTimeUntil }} due to incorrectly entering the current
      routing/account number five times in the EFT tool.</cigna-leaf-alert
    >
  </ng-container>

  <ng-container *ngIf="status === 'wamerror'" data-test="wam-error-message">
    <cigna-leaf-alert
      headerText="Account not activated. "
      variant="banner"
      status="error"
      [notDismissible]="true"
      class="alert-block"
      ><span
        >Contact your
        <button
          style="padding: 0"
          cignaButton="link"
          (click)="openWamFaqModal(true)"
        >
          website access manager.
        </button>
      </span>
    </cigna-leaf-alert>
  </ng-container>

  <ng-container *ngIf="status === 'nowam'" data-test="nowam-error-message">
    <cigna-leaf-alert
      headerText="TIN's access has not been activated."
      variant="banner"
      status="error"
      [notDismissible]="true"
      class="alert-block"
      ><button
        style="padding: 0"
        cignaButton="link"
        (click)="openWamFaqModal(false)"
      >
        Learn more.
      </button></cigna-leaf-alert
    >
  </ng-container>

  <ng-container *ngIf="status === 'deny'" data-test="deny-error-message">
    <cigna-leaf-alert
      headerText="Account Inactive"
      variant="banner"
      status="error"
      [notDismissible]="true"
      class="alert-block"
      style="height: 55px"
    ></cigna-leaf-alert>
  </ng-container>
</ng-container>
